import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '4fr 3fr 4fr 6fr 6fr 2fr 1fr',
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    borderRadius: 20,
    marginBottom: 4,
    backgroundColor: theme.palette.background.default,
    textAlign: 'left',
    height: 52,
    transition: 'background-color 0.3s ease-in-out',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '8fr 3fr 1fr'
    }
  },
  moreIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  skeleton: {
    marginTop: '14px!important',
    marginBottom: '14px!important',
    width: '80%'
  }
}))
export default useStyles
